export const SET_DIALOG = 'SET_DIALOG'
export const SET_ACTIVE_VIEW = 'SET_ACTIVE_VIEW'

export const setDialog = (dialog, modalProps) => ({ type: SET_DIALOG, dialog, modalProps })

export const setActiveView = activeView => ({ type: SET_ACTIVE_VIEW, activeView })
